// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2uwi3","alertIcon":"ConfirmModal_alertIcon__1g0Dk"};